import React from 'react';

type Tone = 'planned' | 'live' | 'neutral';

const tones: Record<Tone, string> = {
  planned: 'bg-amber-50 text-amber-800 border-amber-200',
  live: 'bg-emerald-50 text-emerald-800 border-emerald-200',
  neutral: 'bg-gray-50 text-gray-700 border-gray-200',
};

const Status: React.FC<{ tone?: Tone; children: React.ReactNode; className?: string }> = ({
  tone = 'neutral',
  children,
  className = '',
}) => (
  <span
    className={`inline-block text-xs font-montserrat font-semibold tracking-wide uppercase border rounded-full px-3 py-1 ${tones[tone]} ${className}`}
  >
    {children}
  </span>
);

export default Status;
